import React, { useState, useEffect } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import {
	LoggerProvider,
	PreviewProvider,
	ScriptTagProvider,
	StorageProvider,
	SessionWrapper,
	getCurrentScript,
} from '@rmc/webcx-web-libs';
import { MainApp } from './components/MainApp';
import styles from './App.module.scss';
import { CampaignsProvider } from './context/CampaignsContext';
import { Logger } from './components/Logger';
import { LOGGER_KEY, SCRIPT_ID, LOCAL_STORAGE_KEY } from './config';
import { queryClient } from './api/queryClient';

function App({
	currentScript,
}: {
	currentScript?: HTMLElement | null | SVGScriptElement;
}) {
	const [currentScriptNode, setCurrentScriptNode] = useState<
		HTMLElement | null | SVGScriptElement
	>(null);

	useEffect(() => {
		const script =
			currentScript || getCurrentScript(process.env.REACT_APP_SCRIPT_ID || '');
		setCurrentScriptNode(script);
	}, [currentScript]);

	if (!currentScriptNode) {
		return null;
	}

	return (
		<div className={styles['app-wrapper']}>
			<ScriptTagProvider currentScript={currentScriptNode} scriptId={SCRIPT_ID}>
				<QueryClientProvider client={queryClient}>
					<StorageProvider localStorageKey={LOCAL_STORAGE_KEY}>
						<PreviewProvider>
							<LoggerProvider logKey={LOGGER_KEY}>
								<>
									<Logger domNode={currentScriptNode} />
									<CampaignsProvider>
										<SessionWrapper>
											<MainApp />
										</SessionWrapper>
									</CampaignsProvider>
								</>
							</LoggerProvider>
						</PreviewProvider>
					</StorageProvider>
				</QueryClientProvider>
			</ScriptTagProvider>
		</div>
	);
}

export default App;
